import * as Yup from 'yup';
import { PhoneNumberUtil } from 'google-libphonenumber';

const PHONE_NUMBER_REGEX = /^[0-9+ ]*$/;
const PHONE_NUMBER_MAX_LENGTH = 1000;
const INVALID_PHONE_NUMBER_MESSAGE = 'Invalid phone number';
const PHONE_NUMBER_TO_LONG_MESSAGE = `Phone must be at most ${PHONE_NUMBER_MAX_LENGTH} characters length`;

export const phoneUtil = PhoneNumberUtil.getInstance();

export const validatePhoneNumber = (phoneNumber: string): boolean => {
    try {
        const parsedPhoneNumber = phoneUtil.parse(phoneNumber);
        return PHONE_NUMBER_REGEX.test(phoneNumber) && phoneUtil.isValidNumber(parsedPhoneNumber);
    } catch (error) {
        return false;
    }
};

export const getPhoneValidationSchemaForField = (): Yup.AnySchema =>
    Yup.string()
        .test('is-valid', INVALID_PHONE_NUMBER_MESSAGE, value => {
            if (value) {
                return validatePhoneNumber(value);
            }
            return true;
        })
        .test('length', PHONE_NUMBER_TO_LONG_MESSAGE, value => (value?.length || 0) <= PHONE_NUMBER_MAX_LENGTH);
